import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import  { all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
interface IState {
  hseqData: any;
}
interface IProps {
  GridHeight?: any;
}
export class Incidents extends Component<IProps, IState> {
  private incidentsDetailGrid: GridComponent;
  private incidentsId: number = -1;
  private isAdd: boolean = true;
  public validationRule: Object = { required: true };
  private type: string = 'incident';
  constructor(props: IProps) {
    super(props);
    this.incidentsDetailGrid = new GridComponent(props);
    this.state = {
      hseqData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteIncidents() {
    const obj = {
      id: this.incidentsId,
    };

    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getIncidents(this.type);
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addIncidents(objCommer: any) {
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      description: objCommer.description,
      incident: objCommer.incident,
      id: objCommer.id,
      type: this.type,
    };

    if (this.isAdd) {
      delete obj.id;
      AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getIncidents(this.type);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getIncidents(this.type);
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getIncidents(this.type);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addIncidents(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addIncidents(args.data);
    } else if (args.requestType === 'delete') {
      this.incidentsId = args.data[0].id;
      this.deleteIncidents();
    }
  }
  componentDidMount() {
    this.getIncidents(this.type);
  }

  getIncidents(type: string) {
    getShiftWorkbenchSettings(type)
      .then((el) => {
        this.setState({ hseqData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  render() {
    return (
      <div>
        <GridComponent
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.hseqData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.incidentsDetailGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          enablePersistence
          allowPaging={true}
          actionBegin={this.actionBegin.bind(this)}
          pageSettings={this.pageOptions}
          allowExcelExport
          showColumnMenu={true}
          allowResizing={true}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='incident'
              headerText='Incident Type'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default Incidents;
